<div class="screen">
  <div class="screen-inner">
    <app-shell nav="back" [title]="seasonName" [backTo]="backTo"></app-shell>

    <p class="section-label">Events</p>

    @if (events.length === 0) {
      <p class="page-note">No events yet.</p>
    } @else {
      <div class="card">
        @for (event of events; track event.id) {
          <a class="row" [routerLink]="['/admin/events', event.id]">
            <span class="row-body">
              <span class="row-title">{{ event.name }}</span>
              <span class="row-meta">{{ meta(event) }}</span>
            </span>
            @switch (event.status) {
              @case ('done') { <span class="pill pill-muted">Done</span> }
              @case ('live') { <span class="pill">Live</span> }
            }
            <span class="chevron">&#8250;</span>
          </a>
        }
      </div>
    }

    <button class="btn-primary" type="button" (click)="add()">Add event</button>
    <a class="btn-quiet btn-wide" [routerLink]="['/admin/seasons', seasonId, 'archive']"
       [queryParams]="{ name: seasonName, leagueId: leagueId }">Archive</a>

    @if (error) { <p class="error">{{ error }}</p> }
  </div>
</div>
